module.exports = __webpack_public_path__ + "img/satory17-3.jpeg";